export default __webpack_public_path__ + "static/media/SmallSBExcessiveMovementEdited.54611904.mp4";